import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MySideBar from '../common/MySideBar';

//Create Unit dependencies
import MyTooltip from '../common/MyTooltip';
import CreateCurrencyModel from './CreateCurrencyModel';
import ListCurrencies from './ListCurrencies';

import {
  CREATE_PROJECT_MODEL_ACTION_CREATE, 
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
  ROLE_ADMIN
} from '../common/redux/constantes';


export class DefaultPage extends Component {

  state = {
    openCreateCurrencyDialog:false,
    createCurrencyDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
    currencyEdit:{}
  }


  static propTypes = 
  {
    currency: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };


  closeCreateCurrencyDialog = ()=>
  {
    this.setState({openCreateCurrencyDialog:false});
    this.list.wrappedInstance.refreshTable();
  }

  openCreateCurrencyDialog = ()=>{
    this.setState({
      openCreateCurrencyDialog:true, 
      createCurrencyDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
      currencyEdit:{}
    });
  }

  editCurrency = (currency)=>{
     this.setState({
      openCreateCurrencyDialog:true, 
      createCurrencyDialogAction:CREATE_PROJECT_MODEL_ACTION_EDIT,
      currencyEdit:currency
    });
  }

  showCurrency = (currency)=>{
     this.setState({
      openCreateCurrencyDialog:true, 
      createCurrencyDialogAction:CREATE_PROJECT_MODEL_ACTION_SHOW,
      currencyEdit:currency
    });
  }

  render() {
    return (
      <div >
          <MySideBar>
            <ListCurrencies ref={instance => { this.list = instance; }} editCurrency={this.editCurrency} showCurrency={this.showCurrency}/>
            <CreateCurrencyModel 
              openDialog={this.state.openCreateCurrencyDialog} 
              closeDialog={this.closeCreateCurrencyDialog} 
              actionDialog={this.state.createCurrencyDialogAction}
              currencyEdit={this.state.currencyEdit}
            />
            {
              Number(localStorage.getItem("role")) === ROLE_ADMIN?
              (<MyTooltip openDialog={this.openCreateCurrencyDialog} />)
              :null
            }
        </MySideBar>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    currency: state.currency,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/currency/DefaultPage.js